import React from 'react';
import ErrorState from '@atlassian/jira-common-components-error-state/src/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	isLoading: boolean;
	onRetry: () => void;
};

function Error(props: Props): React.JSX.Element {
	const { isLoading, onRetry } = props;
	const { formatMessage } = useIntl();
	return (
		<ErrorState
			header={formatMessage(messages.header)}
			description={formatMessage(messages.description)}
			isLoading={isLoading}
			onRetry={onRetry}
		/>
	);
}

Error.defaultProps = {
	isLoading: false,
};

export default Error;
